import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Container as Grid, Row } from 'react-bootstrap'

import HintButton from '../HintButton'
import ShowAnswerButton from '../ShowAnswerButton'

import baseStyle from 'Styles/base.css'
import style from './style.css'
import button from 'Styles/button.css'

import documentIcon from 'Assets/document-acqua.svg'

function EbookButton (props) {
  if (props.browser.lessThan.medium || props.splitPane) {
    const ebookSplitPaneStyle = props.splitPane ? style.ebookButtonSplitPaneStyle : ''
    const ebookIconSplitPaneStyle = props.splitPane ? style.ebookIconSplitPaneStyle : ''
    const ebookLegacySplitStyle = props.legacyEbook ? style.legacyEbookButtonStyle : ''
    const ebookLegacyIconSplitStyle = props.legacyEbook ? style.legacyEbookButtonIconStyle : ''

    return (
      <button
        aria-label="Read the ebook page on this topic (no penalty)"
        className={classnames('btn-cdl-secondary', style.ebookButton, ebookSplitPaneStyle, ebookLegacySplitStyle)}
        onClick={props.onClick}
        tabIndex="0"
      >
        <span aria-hidden="true">
          <object
            data={documentIcon} type="image/svg+xml"
            className={classnames(baseStyle.svgIcon, style.ebookIcon,
              ebookIconSplitPaneStyle, ebookLegacyIconSplitStyle)}
            tabIndex="-1"
          />
          {props.children}
        </span>
      </button>
    )
  }

  return (
    <button
      aria-label="Read the ebook page on this topic (no penalty)"
      className={classnames('btn-cdl-secondary', style.ebookButton)}
      onClick={props.onClick}
      data-test-id="readEBookBtn"
      tabIndex="0"
    >
      <div aria-hidden="true">
        <object
          data={documentIcon} type="image/svg+xml"
          className={classnames(style.ebookIcon)}
          tabIndex="-1"
        />
        <span>
          {props.children}
          <br />
          <span className={classnames(button.footerButtonSubtext, style.ebookButtonSubtext)}>(no penalty)</span>
        </span>
      </div>
    </button>
  )
}
EbookButton.propTypes = {
  browser: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  splitPane: PropTypes.bool.isRequired,
  legacyEbook: PropTypes.bool
}

export default function ActivityFooter (props) {
  let splitSmallStyle = ''
  if (props.browser.lessThan.medium ||
    (props.splitPane && (props.footerWidth === '50%')) ||
    (props.splitPane && (window.innerWidth - props.footerWidth) <= 768)) {
    splitSmallStyle = (props.footerWidth === '50%') ||
     (window.innerWidth - props.footerWidth <= 768)
      ? style.splitSmallContainer
      : ''
    return (
      <Row className={classnames(baseStyle.footer, style.mobileFooter, splitSmallStyle)}>
        <div className={style.leftButtonContainer}>
          <EbookButton
            onClick={props.showEbook}
            browser={props.browser}
            splitPane={props.splitPane}
            legacyEbook={props.legacyEbook}
            footerWidth={(props.footerWidth === '50%') ||
             (window.innerWidth - props.footerWidth <= 768)}
          >
            {props.browser.lessThan.medium ? 'E-book' : 'Hide E-book'}
          </EbookButton>
        </div>
        <div className={style.rightButtonContainer}>
          <HintButton
            browser={props.browser}
            onClick={props.showHint}
            questionData={props.curCard}
            splitPane={props.splitPane}
            legacyEbook={props.legacyEbook}
            footerWidth={(props.footerWidth === '50%') ||
             (window.innerWidth - props.footerWidth <= 768)}
          />
          <ShowAnswerButton
            browser={props.browser}
            onClick={props.onDisplayAnswer}
            splitPane={props.splitPane}
            legacyEbook={props.legacyEbook}
            footerWidth={(props.footerWidth === '50%') ||
             (window.innerWidth - props.footerWidth <= 768)}
          />
        </div>
      </Row>
    )
  }
  const getHelpTitleStyle = props.splitPane ? style.getHelpTitleSplit : style.getHelpTitle
  const buttonContainerPadStyle = props.splitPane ? '' : style.buttonContainerLeftMargin
  let ebookLabelText

  if (props.splitPane) {
    ebookLabelText = 'Hide E-book'
  } else {
    ebookLabelText = props.isEbookAvailable ? 'Read the ebook page on this topic' : 'Read about this topic'
  }

  return (
    <Grid>
      <div className={classnames(style.buttonContainer, buttonContainerPadStyle)}>
        <div className={style.leftButtonContainer}>
          <h2 className={classnames(getHelpTitleStyle, 'hidden-xs')}>
            Need help on this question?
          </h2>
          <EbookButton
            onClick={props.showEbook}
            browser={props.browser}
            splitPane={props.splitPane}
            legacyEbook={props.legacyEbook}
          >
            {ebookLabelText}
          </EbookButton>
        </div>
        <div className={style.rightButtonContainer}>
          <HintButton
            browser={props.browser}
            onClick={props.showHint}
            questionData={props.curCard}
            splitPane={props.splitPane}
            legacyEbook={props.legacyEbook}
          />
          <ShowAnswerButton
            browser={props.browser}
            onClick={props.onDisplayAnswer}
            splitPane={props.splitPane}
            legacyEbook={props.legacyEbook}
          />
        </div>
      </div>
    </Grid>
  )
}
ActivityFooter.propTypes = {
  browser: PropTypes.object.isRequired,
  curCard: PropTypes.object.isRequired,
  showHint: PropTypes.func.isRequired,
  showEbook: PropTypes.func.isRequired,
  onDisplayAnswer: PropTypes.func.isRequired,
  isEbookAvailable: PropTypes.bool.isRequired,
  splitPane: PropTypes.bool.isRequired,
  legacyEbook: PropTypes.bool,
  footerWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}
